import { onboardingStepShellClass } from '../Utils/onboardingLayout';

interface RestaurantStepProps {
  restaurantName: string;
  branchName: string;
  branchAddress?: string | null;
  onNext: () => void;
}

export const RestaurantStep = ({
  restaurantName,
  branchName,
  branchAddress,
  onNext
}: RestaurantStepProps) => {
  return (
    <div className={onboardingStepShellClass}>
      <div>
        <h2 className="text-2xl font-semibold tracking-tight text-[#171717]">
          Your restaurant
        </h2>
        <p className="mt-1 text-sm text-[#6f747c]">
          Confirmed from your invite link. Continue to add inventory items.
        </p>
      </div>

      <div className="space-y-3 rounded-lg border border-[#e7e9ee] bg-white p-5">
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-[#6f747c]">
            Name
          </p>
          <p className="mt-1 text-base font-semibold text-[#171717]">
            {restaurantName || 'Restaurant'}
          </p>
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-[#6f747c]">
            Location
          </p>
          <p className="mt-1 text-base font-semibold text-[#171717]">
            {branchName || 'Main'}
          </p>
          {branchAddress ? (
            <p className="mt-0.5 text-sm text-[#6f747c]">{branchAddress}</p>
          ) : null}
        </div>
      </div>

      <button
        type="button"
        onClick={onNext}
        className="rounded-md bg-[#087f8c] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#066873]"
      >
        Continue
      </button>
    </div>
  );
};
